export var lazyFormatPhoneNumber = function(phoneNumber) {
    return import(/* webpackChunkName: "libphonenumber-js" */ "libphonenumber-js").then(function(Module) {
        var parsedPhoneNumber = Module.parsePhoneNumber(phoneNumber);
        return parsedPhoneNumber.country === "US" ? parsedPhoneNumber.formatNational() : parsedPhoneNumber.formatInternational();
    });
};
